import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.75 2C1.7835 2 1 2.7835 1 3.75V7.25C1 8.2165 1.7835 9 2.75 9H21.25C22.2165 9 23 8.2165 23 7.25V3.75C23 2.7835 22.2165 2 21.25 2H2.75ZM21.25 3.5H2.75C2.61193 3.5 2.5 3.61193 2.5 3.75V7.25C2.5 7.38807 2.61193 7.5 2.75 7.5H21.25C21.3881 7.5 21.5 7.38807 21.5 7.25V3.75C21.5 3.61193 21.3881 3.5 21.25 3.5Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.75 10C3.16421 10 3.5 10.3358 3.5 10.75V20.25C3.5 20.3881 3.61193 20.5 3.75 20.5H20.25C20.3881 20.5 20.5 20.3881 20.5 20.25V10.75C20.5 10.3358 20.8358 10 21.25 10C21.6642 10 22 10.3358 22 10.75V20.25C22 21.2165 21.2165 22 20.25 22H3.75C2.7835 22 2 21.2165 2 20.25V10.75C2 10.3358 2.33579 10 2.75 10Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 11.5C9.33579 11.5 9 11.8358 9 12.25C9 12.6642 9.33579 13 9.75 13H14.25C14.6642 13 15 12.6642 15 12.25C15 11.8358 14.6642 11.5 14.25 11.5H9.75Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgArchive;
